<template>
  <div class="my-game">
    <HeadBar title="我的赛事" />

    <div class="news-content">
      <ul v-if="newsList && newsList.length > 0">
        <li v-for="(item, i) in newsList" :key="i">
          <!--赛事相关信息图文展示-->
          <div class="item">
            <van-image fit="contain" lazy-load :src="item.url" :alt="item.matchName" class="news-image" />
            <span class="match-type-icon">{{
              item.onLine === 1 ? "线上赛" : "线下赛"
              }}</span>
          </div>

          <!--赛事相关费用展示-->
          <div class="news-info">
            <div class="news-title">{{ item.matchName }}</div>
            <p class="news-desc">
              姓名: {{ item.name }} ({{ item.sex === 1 ? "男" : "女" }})
            </p>
            <p class="news-desc" v-if="item.projectName">
              参赛项目：{{ item.projectName }}
            </p>
            <p class="news-desc">
              比赛时间: {{ myFormatTime(item.matchTime) }}
            </p>
            <p class="news-desc" v-if="item.price !== null">
              <span class="mainColor">参赛费用:
                <span class="score_time">{{
                  item.price === 0 ? "免费" : `${item.price}元`
                  }}</span>
              </span>
            </p>



            <div class="news-status" v-if="item.state === 1">
              <p>赛事状态：&nbsp;赛事准备中，你应该看不见</p>
            </div>

            <div class="news-status" v-if="item.state === 2">
              <p>赛事状态：&nbsp;报名中</p>
            </div>

            <div class="news-status" v-if="item.state === 3">
              <p>赛事状态：&nbsp;报名结束</p>
            </div>

            <div class="news-status" v-if="item.state === 4">
              <p>赛事状态：&nbsp;赛事已结束</p>
            </div>

            <!-- item.status赛事状态展示 0待支付 1支付但未审核，可能无须支付  2已审核通过 3拒绝 4 完赛 5退款完成 6 已中签 7 未中签 9取消支付 -->

            <!-- 以下两种状态只有state === 2 报名中才会出现 -->

            <!--item.status === 0 待支付 -->
            <div class="news-desc" v-if="item.status === 0">
              <div class="news-status">
                <span class="left">参赛状态：<van-icon name="gold-coin-o" size="16" class="mainColor"
                    style="vertical-align: sub" />&nbsp;未支付</span>
                <!-- 赛事状态为2，才能付款和取消报名 -->
                <div class="right" v-if="item.state === 2">
                  <van-button type="danger" icon="gold-coin-o" round size="small"
                    :url="`pay?id=${item.id}&matchName=${item.matchName}&projectName=${item.projectName}&price=${item.price}&matchTime=${myFormatTime(item.matchTime)}`">
                    立即付款
                  </van-button>
                  <van-button type="danger" icon="gold-coin-o" round size="small" class="ml15px"
                    @click="cancelBaom(item)">取消报名</van-button>
                </div>
                <div class="right" v-else>
                  <van-button type="danger" icon="close" round size="small" class="ml15px">赛事不在报名时间段</van-button>
                </div>
              </div>
              <p class="news-desc" v-if="item.state === 2 && item.expired">支付提醒：请在{{item.expired }}前支付,超时自动取消</p>
            </div>

            <!-- 取消报名或者超时未支付的状态  status == 9  -->
            <div class="news-desc" v-else-if="item.status === 9">
              <div class="news-status">
                <span class="left">参赛状态：<van-icon name="close" size="16" class="mainColor"
                    style="vertical-align: sub" />&nbsp;取消报名</span>
                <div class="right">
                  <van-button v-if="item.state === 2" type="danger" icon="gold-coin-o" round size="small"
                    :url="`gameDetail?matchId=${item.matchId}&onelin=${item.onLine}`">
                    重新去报名
                  </van-button>
                  <van-button v-else type="danger" icon="close" round size="small"
                    :url="`gameDetail?matchId=${item.matchId}&onelin=${item.onLine}`">
                    赛事不在报名时间段
                  </van-button>
                </div>
              </div>
            </div>

            <!-- item.status === 1 支付但未审核 -->
            <div class="news-desc" v-else-if="item.status === 1">
              <div class="news-status">
                <span class="left"
                  v-if="item.state === 2  && item.isDraw === 0 || item.state === 3 && item.isDraw === 0 ">参赛状态：<van-icon
                    name="browsing-history-o" size="16" class="mainColor"
                    style="vertical-align: sub" />&nbsp;报名成功，等待公布参赛号码</span>
                <span class="left"
                  v-else-if="item.state === 2  && item.isDraw === 1 || item.state === 3 && item.isDraw === 1">参赛状态：<van-icon
                    name="browsing-history-o" size="16" class="mainColor"
                    style="vertical-align: sub" />&nbsp;报名成功，等待抽签</span>
                <span class="left" v-else-if="item.state === 4">参赛状态：<van-icon name="browsing-history-o" size="16"
                    class="mainColor" style="vertical-align: sub" />&nbsp;赛事已结束</span>
                <div class="right">
                  <van-button type="danger" icon="more-o" round size="small"
                    :url="`gameDetail?matchId=${item.matchId}&onelin=${item.onLine}`">
                    查看赛事
                  </van-button>
                </div>
              </div>
            </div>


            <!-- 以下5中状态只有state === 3 抽签审核比赛中才会出现 -->
            <!-- item.status === 2 通过审核，可能需要抽签 -->
            <div class="news-desc"
              v-else-if="item.status === 2 && item.state === 3 || item.status === 2 && item.state === 2">
              <!-- 线下赛 -->
              <div class="news-status" v-if="item.onLine === 0">
                <p v-if="item.projectNumber"><span>参赛号码: {{ item.projectNumber }}</span></p>
                <span class="left" v-if="item.isDraw === 1">参赛状态：<van-icon name="passed" size="16" class="mainColor"
                    style="vertical-align: sub" />&nbsp;审核通过，等待抽签</span>
                <span class="left" v-else>参赛状态：<van-icon name="passed" size="16" class="mainColor"
                    style="vertical-align: sub" />{{ item.projectNumber ? "&nbsp;号码已公布，等待比赛" : "&nbsp;审核通过，等待公布参赛号码"
                  }}</span>
              </div>
              <!-- 线上赛 -->
              <div class="news-status" v-if="item.onLine === 1">
                <p v-if="item.projectNumber"><span>参赛号码: {{ item.projectNumber }}</span></p>
                <div v-if="item.onLineUrl === null">
                  <span class="left">参赛状态：<van-icon name="underway-o" size="16" class="mainColor"
                      style="vertical-align: sub" />&nbsp;等待上传完赛证明</span>
                  <div class="right">
                    <van-button type="danger" icon="browsing-history-o" round size="small"
                      :url="`uploadFinish?matchId=${item.matchId}&matchName=${item.matchName}&projectId=${item.projectId}&userId=${item.userId}`">
                      上传完赛证明
                    </van-button>
                  </div>
                </div>
                <div v-else>
                  <span class="left">参赛状态：<van-icon name="underway-o" size="16" class="mainColor"
                      style="vertical-align: sub" />&nbsp;等待审核</span>
                  <div class="right">
                    <van-button type="danger" icon="browsing-history-o" round size="small">等待管理员审核证书</van-button>
                  </div>
                </div>

              </div>

            </div>

            <!-- item.status === 3 审核拒绝 -->
            <div class="news-status"
              v-else-if="item.status === 3 && item.state === 3 || item.status === 3 && item.state === 4">
              <span class="left">参赛状态：<van-icon name="close" size="16" class="mainColor"
                  style="vertical-align: sub" />&nbsp;很遗憾，资料审核失败，若有付款等待组委会退款</span>
            </div>

            <!-- item.status === 6 已经中签 -->
            <div class="news-desc" v-else-if="item.status === 6 && item.state === 3">
              <!-- 线下赛 -->
              <p v-if="item.projectNumber"><span>参赛号码: {{ item.projectNumber }}</span></p>
              <span class="left">参赛状态：<van-icon name="passed" size="16" class="mainColor"
                  style="vertical-align: sub" />&nbsp;恭喜中签，请按时参加比赛</span>
            </div>

            <!-- item.status === 7 未中签  -->
            <div class="news-desc"
              v-else-if="item.status === 7 && item.state === 3 || item.status === 7 && item.state === 4">
              <span class="left">参赛状态：<van-icon name="close" size="16" class="mainColor"
                  style="vertical-align: sub" />&nbsp;很遗憾，未中签，若有付款等待组委会退款</span>
            </div>

            <!-- item.state === 4 结束比赛，有以下两种状态 -->

            <!-- item.status === 4 已完赛 -->
            <div class="news-desc" v-if="item.status === 4 && item.state === 4">
              <p v-if="item.projectNumber">参赛号码: {{ item.projectNumber }}</p>
              <p v-if="item.personalScore">参赛成绩: {{ item.personalScore }}</p>

              <!-- 线下赛 -->
              <div class="news-status" v-if="item.onLine === 0">
                <span class="left">参赛状态：<van-icon name="passed" size="16" class="mainColor"
                    style="vertical-align: sub" />&nbsp;已完赛</span>
                <div class="right">
                  <van-button type="danger" icon="browsing-history-o" round size="small" :url="getScoreUrl(item)">
                    查看成绩
                  </van-button>
                </div>
              </div>

              <!-- 线上赛 -->
              <div class="news-status" v-if="item.onLine === 1">
                <!-- 线上完赛资料审核失败 -->
                <div v-if="item.memo">
                  <span class="left">参赛状态：<van-icon name="underway-o" size="16" class="mainColor"
                      style="vertical-align: sub" />&nbsp;已结束</span>
                  <div class="right">
                    <van-button type="danger" icon="close" round size="small">
                      {{ item.memo }}
                    </van-button>
                  </div>
                </div>
                <div v-else>
                  <span class="left">参赛状态：<van-icon name="underway-o" size="16" class="mainColor"
                      style="vertical-align: sub" />&nbsp;已完赛</span>
                  <div class="right">
                    <van-button type="danger" icon="browsing-history-o" round size="small" :url="getScoreUrl(item)">
                      查看成绩
                    </van-button>
                  </div>
                </div>
              </div>

            </div>

            <!-- item.status === 5 退款完成 -->
            <div class="news-desc" v-else-if="item.status === 5">

              <!-- 线下赛 -->
              <div class="news-status">
                <span class="left">参赛状态：<van-icon name="passed" size="16" class="mainColor"
                    style="vertical-align: sub" />&nbsp;退款完成</span>
              </div>

            </div>


          </div>
        </li>
      </ul>
      <div v-else class="empty">暂无赛事</div>
    </div>
  </div>
</template>

<script>
  import HeadBar from "@/components/HeadBar.vue";
  import {
    fetchHttp,
    getDayTime,
  } from "@/util/fn.js";
  import { Toast, Button, Dialog, Image as VanImage } from "vant";

  export default {
    name: "home",
    components: {
      HeadBar,
      [Button.name]: Button,
      [VanImage.name]: VanImage,
    },
    data() {
      return {
        newsList: [], //NEWS_LIST
        userId: Cookies.get('USERID'),
      };
    },
    computed: {},
    mounted() {
      // this.userId = '3006';
      // setCookie('FMTY_TOKEN', 'eyJhbGciOiJIUzI1NiJ9.eyJzdWIiOiIxODgxMjM0NTY3OCIsImlkIjozMDA2LCJleHAiOjE2MTk5NzY3NDQsImlhdCI6MTYxOTYxNjc0NCwianRpIjoiN2FiMmFmYTYtMTU0NS00MzIyLThjMGEtMTliM2M5M2UxZmIyIiwidXNlcm5hbWUiOiIxODgxMjM0NTY3OCJ9.4xu15R7WN57rTLxEfSFtrsQYT3Qq5goG2rww0bQHFy4');
      fetchHttp(
        "marathon/result/personalAllMatchInfo",
        { id: this.userId, domain: 0 },
        "GET"
      ).then((res) => {
        if (res && res.code === 0) {
          let matchList = res.data;
          let renderList = [];
          let matchIdList = [];
          matchList && matchList.length > 0 && matchList.map((item, index) => {
            console.log(item.matchId)
            if (!matchIdList.includes(item.matchId)) {
              matchIdList.push(item.matchId)
              renderList.push(item);
            }
          });
          this.newsList = renderList;
        }
      });
    },
    methods: {
      cancelBaom(item) {
        Dialog.confirm({
          title: "取消报名",
          message: "确定要取消报名吗？",
        })
          .then(() => {
            fetchHttp(
              "marathon/signUp/cancelSignUp",
              { userId: item.userId, projectId: item.projectId, id: item.id },
              "GET"
            ).then((res) => {
              if (res && res.code === 0) {
                Toast("取消报名成功");
                setTimeout(() => {
                  window.location.reload();
                }, 2000);
              } else {
                Toast(res.message);
              }
            });
          })
          .catch(() => {
            // on cancel
          });

        console.log(item.userId, item.projectId, item.id);
      },

      myFormatTime(time) {
        return getDayTime(time);
      },
      getScoreUrl(item) {
        let url = `scoreDetail?userId=${item.userId ? item.userId : this.userId
          }&matchId=${item.matchId}&projectId=${item.projectId}`;
        if (item.regularUrl) {
          url = item.regularUrl;
        }
        return url;
      },
      onSubmit() {
        Toast("报名列表");
      },
    },
  };
</script>
<style scope lang="less">
  .my-game {
    background: #efefef;
    overflow: hidden;
  }

  .mainColor {
    color: red;
  }

  .news-content p {
    margin: 0;
  }

  .news-content li {
    float: left;
    width: 100%;
    margin: 10px 0 0;
    color: #333;
    font-size: 14px;
  }

  .news-content .news-title {
    width: 100%;
    height: 20px;
    line-height: 20px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    color: #333;
    font-size: 16px;
    font-weight: bold;
    border-left: 3px solid #e50021;
    padding-left: 5px;
    margin: 5px 0;
  }

  .news-content li {
    text-decoration: none;
    width: 100%;
    padding: 10px;
    background: #fff;
    border: 1px solid #f2f2f2;
    text-align: left;
  }

  .news-content li:hover {
    border: 1px solid #e50021;
  }

  .news-content .news-info {
    line-height: 32px;
  }

  .border-none {
    border-right: none !important;
  }

  .notesText {
    color: #999999;
    margin-top: 10px;
  }

  .news-content .item {
    overflow: hidden;
    position: relative;
  }

  .news-content .match-type-icon {
    position: absolute;
    background: #e50021;
    color: #fff;
    left: 0;
    top: 0;
    width: 80px;
    text-align: center;
    padding: 0;
    margin: 0;
    font-size: 16px;
  }

  .news-content .score_time {
    font-size: 20px;
    font-family: Chalet_out;
    color: #e50021;
  }

  .news-content .news-image {
    width: 100%;
    border-radius: 5px;
  }

  .news-status {
    float: left;
    width: 100%;

    .left {
      float: left;
    }

    .right {
      float: right;
      margin: -5px 0 5px 0;
    }
  }

  .empty {
    margin-top: 30px;
    background-color: #fff;
    text-align: center;
  }

  .btmr5 {
    margin-right: -50px;
  }

  .ml15px {
    margin-left: 15px;
  }
</style>